// extracted by mini-css-extract-plugin
module.exports = {"complainIcon":"product-view-complainicon_complainIcon__39C53"};